import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Welcome to Luxor");
      nav("/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="register-page" className="min-h-[100vh] grid grid-cols-1 lg:grid-cols-2 bg-[#F5EFE4]">
      <div className="flex items-center justify-center p-8 lg:p-16 pt-32 lg:pt-16 order-2 lg:order-1">
        <form onSubmit={submit} className="w-full max-w-md">
          <p className="overline">Request access</p>
          <h1 className="font-serif text-5xl mt-4 text-[#1A1815]">Join Luxor.</h1>
          <div className="mt-8 space-y-5">
            <div><label className="luxor-label">Full Name</label><input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="luxor-field" data-testid="register-name" /></div>
            <div><label className="luxor-label">Email</label><input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="luxor-field" data-testid="register-email" /></div>
            <div><label className="luxor-label">Phone</label><input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="luxor-field" data-testid="register-phone" /></div>
            <div><label className="luxor-label">Password</label><input type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="luxor-field" data-testid="register-password" /></div>
          </div>
          <button disabled={loading} data-testid="register-submit" className="luxor-btn-primary w-full mt-8 justify-center disabled:opacity-50">{loading ? "Creating…" : "Create Account"}</button>
          <p className="text-sm text-[#6B665E] mt-6">
            Already a client? <Link to="/login" className="text-[#C5A059] hover:underline" data-testid="register-to-login">Sign in</Link>
          </p>
        </form>
      </div>
      <div className="relative hidden lg:block order-1 lg:order-2">
        <img src="https://images.unsplash.com/photo-1661954864180-e61dea14208a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600" alt="Luxor" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#1A1815] via-[#1A1815]/40 to-transparent" />
        <div className="absolute bottom-0 p-12">
          <p className="overline">Members portal</p>
          <h2 className="font-serif text-4xl lg:text-5xl mt-3 max-w-md leading-tight text-[#F5EFE4]">A quieter way to live.</h2>
        </div>
      </div>
    </div>
  );
}
